import {useRef,useEffect, useState} from 'react';
import { useSelector,useDispatch } from 'react-redux';
import { modalModifShow,modif,update,current } from "./CategoriesSlice";
import axios from 'axios';

export default function ModalModifer() {

    const categoriedata = useSelector(state => state.categoriesData);
    const currentelement = categoriedata.current;
    const modalShow = categoriedata.modalModifShow;
    const id = useSelector(state => state.userData.id);

    const [loading,setLoading] =useState(false)
    const [etat,setEtat] =useState('')

    const designationField=useRef()


    const ChampUpdate = () =>{
        const designation=designationField.current.value;
        const _id=currentelement._id;
        const data={_id,designation};
        dispatch(current(data));
    }

    const Ajouter = async ()=> {
        const designation=designationField.current.value.trim()
        if(designation==="")
            {
                alert("Désignation vide");
                return;
            }
            setEtat('')
            setLoading(true)
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const idcategorie = currentelement._id;
            const response = await axios.post(`${apiUrl}edit/categorie/${id}/${idcategorie}`, {
                designation,
            });
            if(response.data.status==="ok")
                {
                    const data={idcategorie,designation};
                    dispatch(modalModifShow(false));
                    dispatch(modif(true));
                    dispatch(update(data));
                }
            else{
                setEtat('erreur');
            }
        } catch (error) {
            setEtat('erreur');
        }
        setLoading(false)
    }

    const dispatch= useDispatch();
    const Close = () => {
        dispatch(modalModifShow(false));
        setEtat('');
        
    };

    useEffect(() =>{
        setEtat('');
      },[]);

    return (
        <div className={`modal fade ${modalShow ? 'show' : ''}`} style={{ display: modalShow ? 'block' : 'none' }} role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Modifier catégorie</h5>
                    </div>
                    <div className="modal-body">
                    {etat==='erreur' ?
                                <div class="alert alert-danger  mb-4 text-center" role="alert">
                                <strong>Erreur de connexion</strong>
                            </div>                 
                        :
                        ''                    
                    }
                    <label className="form-label" for="designation">Désignation</label>
                    <input type="text" className="form-control" id="designation" onChange={ChampUpdate} value={currentelement.designation} placeholder="Désignation du fournisseur" ref={designationField}></input>

                    </div>
                    <div className="modal-footer">
                        {loading ?
                        <>
                <div className="mt-4 d-flex justify-content-center">
                <button class="btn btn-success" type="button" disabled>
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                <span class="sr-only">Enregistrement...</span>
                </button>
                </div> 
                        </>
                        :
                        <>
                        <button type="button" className="btn btn-success" onClick={Ajouter}>Enregistrer</button>
                        <button type="button" className="btn btn-secondary" onClick={Close}>Annuler</button>
                        </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );

    }


